const WHITELISTED_HEADERS = ['flavour', 'auth', 'resjwttoken', 'client-id', 'version'];

export let commonHeaders: { [k: string]: string } = {};

const cacheCommonHeaders = () => {
    commonHeaders =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        typeof window?.getiOSHeader === 'function'
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window?.getiOSHeader?.() || { 'client-id': 'patient-mweb' }
            : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            typeof window?.Eka?.getHeaders === 'function'
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              JSON.parse(window?.Eka?.getHeaders?.() || '{"client-id":"patient-mweb"}')
            : { 'client-id': 'patient-mweb' };

    Object.keys(commonHeaders).map((k) => {
        if (WHITELISTED_HEADERS.indexOf(k.toLowerCase()) === -1) {
            delete commonHeaders[k];
        }
    });
};

cacheCommonHeaders();

const refreshToken = async () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window?.Eka?.updateToken === 'function') {
        return new Promise((res) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.refreshCallback = () => {
                cacheCommonHeaders();
                res(true);
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.Eka.updateToken('refreshCallback');
        });
    } else if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof window?.webkit?.messageHandlers?.statusCodeHandler?.postMessage === 'function'
    ) {
        return new Promise((res) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.refreshCallback = () => {
                cacheCommonHeaders();
                res(true);
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window?.webkit?.messageHandlers?.statusCodeHandler?.postMessage(
                JSON.stringify({ status: 401 }),
            );
        });
    }
};

const fetchWithRefreshV2 = async (url: RequestInfo, options?: RequestInit) => {
    const headers = options?.headers ? new Headers(options.headers) : new Headers();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (commonHeaders) {
        const listOfCommonHeader = Object.keys(commonHeaders);
        listOfCommonHeader.forEach((headerItem) => {
            headers.append(headerItem, commonHeaders[headerItem]);
        });
    } else {
        headers.append('client-id', 'patient-mweb');
    }

    const res = await fetch(url, { ...options, mode: 'cors', credentials: 'include', headers });

    if (res.status === 401) {
        await refreshToken();

        const listOfCommonHeader = Object.keys(commonHeaders);
        listOfCommonHeader.forEach((headerItem) => {
            headers.set(headerItem, commonHeaders[headerItem]);
        });

        const res = await fetch(url, { ...options, mode: 'cors', credentials: 'include', headers });
        return res;
    }

    return res;
};

export default fetchWithRefreshV2;
